import { Outlet } from "react-router";
import Header from "../../components/Header";
import Page from "../../layouts/Page";

const HowToPage = () => {
  return (
    <>
      <Header
        heading="How To"
        tabs={[
          { to: "suspension", text: "Suspension" },
          { to: "geometry-and-adjustments", text: "Geometry and adjustments" },
        ]}
      />
      <Page>
        <Outlet />
      </Page>
    </>
  );
};

export default HowToPage;
